import { render, staticRenderFns } from "./AddPrivilegeGroup.vue?vue&type=template&id=6c291a92&scoped=true"
import script from "./AddPrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./AddPrivilegeGroup.vue?vue&type=script&lang=js"
import style0 from "./AddPrivilegeGroup.vue?vue&type=style&index=0&id=6c291a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c291a92",
  null
  
)

export default component.exports